import { axios } from '~/clients';
import { GET_DELIVERY_PICKUP } from '~/constants/endpoints';
import { InventoryTypeId } from '~/constants/inventoryType';
import { DeliveryPickupResponse } from '~/services/common/contracts';
import { BrowserCookies } from '~/utilities';

const deliveryPickupNinetyNinthPercentile = 2200;

type BulkVehiclePayload = {
  locationId: number;
  vehicleId: number;
  vehicleInventoryType: InventoryTypeId;
};

const getBulkAvailabilityInfo = async (
  vehicles: BulkVehiclePayload[],
  zip: string,
  correlationId?: string,
  userId?: string
) => {
  const requestVehicles = vehicles.map(
    ({ locationId, vehicleId, vehicleInventoryType }) => ({
      VehicleLocationId: locationId,
      vehicleId,
      vehicleInventoryType
    })
  );
  const { data } = await axios.post<DeliveryPickupResponse>(
    GET_DELIVERY_PICKUP,
    {
      userId,
      vehicles: requestVehicles,
      zipCode: zip
    },
    {
      headers: {
        browsercookieid: BrowserCookies.get('BrowserCookieId') ?? '',
        clientid: 'vdp_ui',
        correlationId
      },
      timeout: deliveryPickupNinetyNinthPercentile
    }
  );

  if (!data.content) {
    throw new Error(data.errorMessage);
  }

  return data.content.map(vehicle => {
    const pickupDaysToAvailability =
      vehicle.soonestPickup.content?.daysToAvailability ?? 999;
    const deliveryDaysToAvailability =
      vehicle.soonestDelivery.content?.daysToAvailability ?? 999;

    return deliveryDaysToAvailability <= pickupDaysToAvailability
      ? {
          vehicleId: vehicle.vehicleId,
          earliestDaysToAvailability:
            vehicle.soonestDelivery.content?.daysToAvailability,
          earliestAvailabilityDate: vehicle.soonestDelivery.content
            ?.utcSoonestDateTimeIso
            ? new Date(vehicle.soonestDelivery.content.utcSoonestDateTimeIso)
            : undefined
        }
      : {
          vehicleId: vehicle.vehicleId,
          earliestDaysToAvailability:
            vehicle.soonestPickup.content?.daysToAvailability,
          earliestAvailabilityDate: vehicle.soonestPickup.content
            ?.utcSoonestDateTimeIso
            ? new Date(vehicle.soonestPickup.content?.utcSoonestDateTimeIso)
            : undefined
        };
  });
};

export default getBulkAvailabilityInfo;
